exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".development{background-color:#09f !important}.development .sidebar-title{color:#000}.staging{background-color:#dcfa00 !important}.staging .sidebar-title{color:#000 !important}.production{background-color:#2b2f3a !important}.production .sidebar-title{color:#fff !important}.collapse .sidebar-title{margin-left:-11px !important}\n", ""]);

// exports
